import React from "react";
import "./bestOption.scss";

//Imagens:
import ImgBestOption from "../../../../assets/financial/vetorFinancial.png";
import { useTranslation } from "react-i18next";

function BestOption() {
  const { t } = useTranslation()

  return (
    <div className="container-best-option">
      <div className="img-best-option">
        <img src={ImgBestOption} alt="" />
      </div>
      <div className="text-best-option">
        <h1>{t("financial_services.title")}</h1>
        <p>{t("financial_services.section_text_1")}</p>
        <p>{t("financial_services.section_text_2")}</p>
        <p>{t("financial_services.section_text_3")}</p>
        <a href="/form">
          <button id="btn-best-option">{t("buttons.demo_btn_alternative_text_1")}</button>
        </a>
      </div>
    </div>
  );
}

export default BestOption;
